import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "edit-team-member-form" }
const _hoisted_2 = { class: "readonly-field" }
const _hoisted_3 = { class: "readonly-field-label" }
const _hoisted_4 = { class: "readonly-field-value" }
const _hoisted_5 = { class: "readonly-field" }
const _hoisted_6 = { class: "readonly-field-label" }
const _hoisted_7 = { class: "readonly-field-value" }
const _hoisted_8 = { class: "active-field" }
const _hoisted_9 = {
  key: 0,
  class: "loading apollo"
}

import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useToast } from "vue-toastification";
import { useMutation } from "@vue/apollo-composable";
import { logErrorMessages } from "@vue/apollo-util";

import Modal from "@/components/Modal.vue";
import FormItem from "@/components/form/FormItem.vue";
import BasicButton from "@/components/BasicButton.vue";

import { UPDATE_PROJECT_TEAM_MEMBER } from "@/graphql/project/mutations";
import { GET_PROJECT_TEAM } from "@/graphql/project/queries";

import enUK from "@/locales/project/en-UK.json";
import { TeamMember } from "@/helpers/project/typesDefinition";


export default /*@__PURE__*/_defineComponent({
  __name: 'EditProjectTeamMember',
  props: {
  projectId: {
    type: String,
    required: true,
  },
  teamMember: {
    type: Object as () => TeamMember,
    required: true,
  },
},
  emits: ["close", "updated"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t } = useI18n({
  useScope: "global",
  inheritLocale: true,
  messages: {
    "en-UK": enUK,
  },
});

const toast = useToast();

const fullName = computed(() => {
  return [props.teamMember.user.firstName, props.teamMember.user.lastName]
    .filter(Boolean)
    .join(" ");
});

const roleName = computed(() => {
  return props.teamMember.projectRole.name;
});

const editHourlyRate = ref<number | string>(
  props.teamMember.projectRole.hourlyRate / 100,
);

const editActive = ref<boolean>(props.teamMember.active ?? false);

watch(
  () => props.teamMember,
  (teamMember) => {
    editHourlyRate.value = teamMember.projectRole.hourlyRate / 100;
    editActive.value = teamMember.active ?? false;
  },
);

const {
  mutate: updateProjectTeamMember,
  onError: onUpdateProjectTeamMemberError,
  onDone: onUpdateProjectTeamMemberDone,
  loading: updatingProjectTeamMember,
} = useMutation(UPDATE_PROJECT_TEAM_MEMBER, {
  refetchQueries: [
    {
      query: GET_PROJECT_TEAM,
      variables: {
        id: props.projectId,
      },
    },
  ],
});

onUpdateProjectTeamMemberError((error) => {
  logErrorMessages(error);
  toast.error(t("errors.updateTeamMember"));
});

onUpdateProjectTeamMemberDone(() => {
  toast.success(t("success.updateTeamMember"));
  emit("updated");
  emit("close");
});

const isLoading = computed(() => {
  return updatingProjectTeamMember.value;
});

async function handleUpdateProjectTeamMember(): Promise<void> {
  if (editHourlyRate.value === "" || editHourlyRate.value === null) {
    toast.error(t("errors.requiredFields"));
    return;
  }

  const hourlyRateInCents =
    typeof editHourlyRate.value === "string"
      ? Math.round(parseFloat(editHourlyRate.value) * 100)
      : Math.round(editHourlyRate.value * 100);

  if (isNaN(hourlyRateInCents)) {
    toast.error(t("errors.invalidHourlyRate"));
    return;
  }

  await updateProjectTeamMember({
    input: {
      userId: props.teamMember.user.id,
      projectRoleId: props.teamMember.projectRole.id,
      hourlyRate: hourlyRateInCents,
      active: editActive.value,
    },
  });
}

function closeModal(): void {
  emit("close");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, { onClose: closeModal }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("titles.editTeamMember")), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("labels.fullname")), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(fullName.value), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)("labels.role")), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(roleName.value), 1)
        ]),
        _createVNode(FormItem, {
          input: editHourlyRate.value,
          "onUpdate:input": _cache[0] || (_cache[0] = ($event: any) => ((editHourlyRate).value = $event)),
          label: _unref(t)('labels.hourlyRate'),
          name: "hourlyRate",
          "input-type": "basic"
        }, null, 8, ["input", "label"]),
        _createElementVNode("label", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editActive).value = $event)),
            type: "checkbox"
          }, null, 512), [
            [_vModelCheckbox, editActive.value]
          ]),
          _createElementVNode("span", null, _toDisplayString(_unref(t)("labels.active")), 1)
        ])
      ]),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(t)("loading")), 1))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createVNode(BasicButton, {
        class: "edit-button",
        type: "submit",
        disabled: isLoading.value,
        onClick: handleUpdateProjectTeamMember
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("buttons.save")), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(BasicButton, {
        class: "cancel-button",
        onClick: closeModal
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("buttons.cancel")), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})